export function useGlobalScroll() {
  if (import.meta.env.SSR)
    return {}

  const scrollLock = useScrollLock(document.body)

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const infiniteScrollListener = (element: Ref<HTMLElement | null>, onScroll: () => void) => {
    useInfiniteScroll(
      element,
      onScroll,
      { distance: 660 },
    )
  }

  const windowResizeListener = (onResize: () => void) => {
    useEventListener(window, 'resize', onResize)
  }

  return {
    scrollLock,
    scrollTop,
    infiniteScrollListener,
    windowResizeListener,
  }
}
